<template>
  <div class="payment-plan">
    <div
      class="d-flex flex-row justify-content-start align-items-center flex-nowrap"
    >
      <div class="payment-plan-field w-100">
        <div class="prepend">
          <span class="text-uppercase">
            {{ paymentPlan.currency }}
          </span>
        </div>
        <div class="content">
          <span v-if="paymentPlan.activation_code">
            <i class="far fa-lock-alt c-coral mr-1"></i>
          </span>
          {{ paymentPlanText }}
        </div>
      </div>
      <div class="actions-container ml-3 d-flex flex-row flex-nowrap">
        <span
          v-if="paymentPlan.activation_code"
          v-clipboard:copy="purchaseUri"
          class="clickable mr-3"
          v-tooltip="{
            content: $t('PRODUCTS.TEXT.COPY_SECRET_LINK_TO_CLIPBOARD'),
            delay: 100,
            placement: 'top',
            container: 'body',
            trigger: 'click hover',
          }"
        >
          <i class="far fa-link"></i>
        </span>
        <span class="clickable mr-3" @click="$emit('edit')">
          <i class="far fa-pencil-alt"></i>
        </span>
        <span
          class="clickable"
          v-confirm="{
            title: $t('PRODUCTS.LINK.DELETE_PAYMENT_PLAN'),
            text: $t('PRODUCTS.TEXT.DELETE_PAYMENT_PLAN_DESCRIPTION'),
            confirmButton: $t('PRODUCTS.LINK.DELETE_PAYMENT_PLAN'),
            confirm: () => remove(),
          }"
        >
          <i class="far fa-trash-alt"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default {
  name: 'ProductPaymentPlan',
  props: {
    paymentPlan: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
    }),
    paymentPlanText() {
      const p = this.paymentPlan;
      return this.$tc(
        'PRODUCTS.TEXT.PAYMENT_PLAN_DESCRIPTION_VARIANT',
        p.number_of_subsequent_payments,
        {
          initialPaymentAmount: p.initial_payment_amount,
          numberOfSubsequentPayments: p.number_of_subsequent_payments,
          subsequentPaymentAmount: p.subsequent_payment_amount,
          billingFrequencyDays: p.billing_frequency_days,
        }
      );
    },
    purchaseUri() {
      const productId = this.paymentPlan.product;
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/buy/product/${productId}?pp=${this.paymentPlan.activation_code}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/buy/product/${productId}?pp=${this.paymentPlan.activation_code}`
        );
        return uri;
      }
    },
  },
  methods: {
    async remove() {
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.clickable {
  cursor: pointer;
  color: $medium-gray;
  &:hover {
    color: var(--brand-color, $coral);
  }
}

.payment-plan-field {
  display: flex;
  flex-wrap: nowrap;
  border-radius: $border-radius;
  border: 1px solid $medium-gray;

  .prepend {
    padding: 0.75rem;
  }

  .content {
    border-left: 1px solid $medium-gray;
    padding: 0.75rem;
    color: $charcoal;
  }
}
</style>
